import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Collapse,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { withTranslation } from "react-i18next";

import VerticalLayoutMenu from "./index";
import { getSidebarList } from "./sidebarMenuList";
import colors from "assets/scss/colors.module.scss";

const color = colors.sidebarTextColor;

const SubMenuList = ({ subList, isDrawerOpen, t }) => {
  const roles = useSelector((state) => state.Login.roles);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const handleClick = (subList) => {
    if (subList.url) {
      navigate(subList.url);
    }
    setOpen(!open);
  };

  useEffect(() => {
    const recurtionFn = (MENU) => {
      MENU.forEach((element) => {
        if (element.child) {
          recurtionFn(element.children);
        } else {
          if (
            pathname
              .toLowerCase()
              .includes(
                (subList.typeName || subList.url || subList.name)
                  .toLowerCase()
                  .replace(/ /g, "")
              )
          ) {
            setOpen(true);
            setActive(true);
          } else {
            setOpen(false);
            setActive(false);
          }
        }
      });
    };
    recurtionFn(getSidebarList(roles));
  }, [pathname]);

  return (
    <>
      <ListItem
        key={subList.name}
        disablePadding
        sx={{ display: "block", color: active ? "white" : color }}
      >
        <ListItemButton
          onClick={() => handleClick(subList)}
          sx={{
            gap: "10px",
            paddingTop: 0,
            paddingBottom: "10px",
            pl: subList.parentName
              ? subList.level > 1
                ? `${subList.level * 12 + 32}px`
                : "32px"
              : 2,
            "&:hover *": {
              color: "white",
            },
          }}
        >
          <ListItemIcon
            sx={{
              color: active ? "white" : color,
              minWidth: "unset",
              "& svg": {
                fontSize: isDrawerOpen ? "18px" : "20px",
              },
            }}
          >
            {subList?.icon}
          </ListItemIcon>
          <ListItemText
            primary={t(subList.name)}
            primaryTypographyProps={{ style: { whiteSpace: "normal" } }}
            sx={{
              "& span": {
                fontSize: "14px",
              },
            }}
          />
          {subList?.children?.length &&
            (!open ? (
              <KeyboardArrowRightIcon
                style={{
                  color: active ? "white" : color,
                  minWidth: "unset",
                  fontSize: "18px",
                }}
              />
            ) : (
              <ExpandMore
                style={{
                  color: active ? "white" : color,
                  minWidth: "unset",
                  fontSize: "18px",
                }}
              />
            ))}
        </ListItemButton>
      </ListItem>

      <Collapse in={open}>
        {subList?.children?.length ? (
          <VerticalLayoutMenu
            menuItem={subList?.children || []}
            isDrawerOpen={isDrawerOpen}
          />
        ) : null}
      </Collapse>
    </>
  );
};

export default withTranslation()(SubMenuList);

SubMenuList.propTypes = {
  subList: PropTypes.object,
  isDrawerOpen: PropTypes.bool,
  t: PropTypes.func,
};
